import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { AppAuthService } from '@prodcard/core'
import PasswordResetForm from './PasswordResetForm.vue'
import { useRouter } from 'vue-router'

interface Props {
  authService: AppAuthService
  email?: string
  redirect?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetPage',
  props: {
    authService: {},
    email: {},
    redirect: { default: '/' }
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()
const loading = ref(false)

const login = async () => {
  await router?.push({ path: '/password-change', query: { redirect: props.redirect } })
}

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { width: "500" }, {
    default: _withCtx(() => [
      _createVNode(PasswordResetForm, {
        "auth-service": _ctx.authService,
        "pre-filled-email": _ctx.email,
        loading: loading.value,
        onLogin: login
      }, null, 8, ["auth-service", "pre-filled-email", "loading"])
    ]),
    _: 1
  }))
}
}

})